import { render, staticRenderFns } from "./AddUpdateDiscount.vue?vue&type=template&id=9be0c060"
import script from "./AddUpdateDiscount.vue?vue&type=script&lang=js"
export * from "./AddUpdateDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports